import { useMemo } from "react";

import { useGetStores } from "@/api";
import { useAuthStore } from "@/stores/auth.store";
import { useSessionStore } from "@/stores/session.store";

export function useActiveStoreName() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const activeStoreId = useSessionStore((state) => state.activeStoreId);

  const { data } = useGetStores(undefined, {
    query: { enabled: isAuthenticated },
  });

  return useMemo(() => {
    if (activeStoreId === null) return undefined;

    const stores = data?.data?.data ?? [];
    return stores.find((store) => store.id === activeStoreId)?.name;
  }, [activeStoreId, data]);
}
